import axios from "axios";
import { Toast } from "vant";
import store from '@/store'

var baseURL;
if (process.env.NODE_ENV === 'development') {
    baseURL = '/api';
} else {
    baseURL = '/opus/api';
}
let loading;
let duration = 2 * 1000;

function startLoading() {
    loading = Toast.loading({
        message: '数据加载中...',
        forbidClick: true,
        overlay: true,
    });
}

function stopLoading() {
    loading.clear();
}

//取消重复接口
function removeCommonPending(config) {
    for(let i in store.state.axiosCancel.axiosPromiseCancel){
        if(store.state.axiosCancel.axiosPromiseCancel[i].u===config.url+'&'+config.method){
            store.commit('axiosCancel/clearCommonAxiosPromiseCancelArr', i);
        }
    }
}

export const ExcludeRequest400 = ['/opus/generateStsUploadSignMessage'] // 排除的请求


// axios.defaults.headers.get['Pragma'] = 'no-cache';
// axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';
axios.defaults.headers = {}

const service = axios.create({
    baseURL,
    timeout: 86400000,
    headers: {}
    // headers: {
    //     // 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    //     'content-type': "application/json;charset=UTF-8"
    // }
});


service.interceptors.request.use(
    config => {
        if (!config.stopLoading) {
            startLoading();
        }
        //取消当前重复未响应的接口
        removeCommonPending(config)
        // 发起请求时保存当前页面的所有请求
        config.cancelToken=new axios.CancelToken((cancel)=>{
            store.commit('axiosCancel/setAxiosPromiseCancelArr', {u:config.url+'&'+config.method,f:cancel});
        })
        return config;
    },
    error => {
        console.log(error); // for debug
        loading&&stopLoading();
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        if (loading) {
            stopLoading();
        }
        const { status, data } = response;
        if (response instanceof Blob) {
            return response;
        }
        if (status !== 200) {
            Toast({
                message: data.message || "Error",
                duration
            });
            return false;
        } else {
            return data
        }
    },
    error => {
        if (loading) {
            stopLoading();
        }
        if(axios.isCancel(error)){
            return new Promise(()=>{});
        }
        return Promise.reject(error.response);
    }
);

export default service;